import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  openHelpDialog: boolean = false;
  constructor() { }

  openHelpModal = () => {
    this.openHelpDialog = true;
  }
  navigateToSyncWebPanel(): void {
    window.location.href = `${environment.syncCpHost}/login`;
  }
  openSyncCom(): void {
    window.location.href = "https://www.sync.com/";
  }
}
